module.exports = __webpack_public_path__ + "static/img/HomeBanner1.b0c6815.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HomeBanner1.gif
// module id = t20Z
// module chunks = 0